import React, { FC } from "react";

import { faUndoAlt } from "@fortawesome/pro-solid-svg-icons/faUndoAlt";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "antd/es/tooltip";
import { defineMessages, useIntl } from "react-intl";

import { Alert, Button } from "@mapmycustomers/ui";

const messages = defineMessages({
  message: {
    id: "dashboard.cards.temporaryConfigAlert",
    defaultMessage: "Time range changed temporarily",
    description:
      "Message in a temporary configuration alert which appears when you make an inline change in Dashboard card via its title",
  },
  saveButton: {
    id: "dashboard.cards.temporaryConfigAlert.saveButton",
    defaultMessage: "Save for everyone",
    description:
      "Save Button in a temporary configuration alert which appears when you make an inline change in Dashboard card via its title",
  },
  undo: {
    id: "dashboard.cards.temporaryConfigAlert.undo.tooltip",
    defaultMessage: "Undo",
    description:
      "Undo Button's tooltip in a temporary configuration alert which appears when you make an inline change in Dashboard card via its title",
  },
});

export interface TemporaryConfigurationAlertProps {
  onSave?: () => void;
  onUndo?: () => void;
}

const TemporaryConfigurationAlert: FC<TemporaryConfigurationAlertProps> = ({ onSave, onUndo }) => {
  const intl = useIntl();

  return (
    <Alert
      action={
        onSave && (
          <Button onClick={onSave} size="small" type="primary">
            {intl.formatMessage(messages.saveButton)}
          </Button>
        )
      }
      closable
      closeIcon={
        <Tooltip title={intl.formatMessage(messages.undo)}>
          <FontAwesomeIcon icon={faUndoAlt} />
        </Tooltip>
      }
      message={intl.formatMessage(messages.message)}
      onClose={onUndo}
      showIcon
      type="warning"
    />
  );
};

export default TemporaryConfigurationAlert;
